<ng-container *transloco="let t">
  @if (
    {
      addressErrorMessage: addressErrorMessage$ | async,
      zipCodeErrorMessage: zipCodeErrorMessage$ | async,
      cityErrorMessage: cityErrorMessage$ | async,
    };
    as data
  ) {
    <div [formGroup]="form">
      <!-- Adress -->
      <div class="form-group">
        <lib-input-container
          for="{{ name }}-address"
          [label]="t('worksite_address')"
          [required]="true"
          [errorText]="data.addressErrorMessage"
        >
          <input
            vinnova-text-input
            id="{{ name }}-address"
            formControlName="address"
            autocomplete="new-password"
            spellcheck="false"
            [error]="!!data.addressErrorMessage"
          />
        </lib-input-container>
      </div>
      <div class="row zip-and-city-row">
        <!-- Postnummer -->
        <div class="form-group col-md-5 col-sm-12">
          <lib-input-container
            for="{{ name }}-zipCode"
            [label]="t('worksite_postal_code')"
            [required]="true"
            [errorText]="data.zipCodeErrorMessage"
          >
            <input
              vinnova-text-input
              id="{{ name }}-zipCode"
              formControlName="zipCode"
              autocomplete="new-password"
              [inputType]="isForeign ? undefined : InputType.Zipcode"
              spellcheck="false"
              [error]="!!data.zipCodeErrorMessage"
              (input)="toUpper($event)"
            />
          </lib-input-container>
        </div>
        <!-- Postort -->
        <div class="form-group col-md-7 col-sm-12">
          <lib-input-container
            for="{{ name }}-city"
            [label]="t('worksite_city')"
            [required]="true"
            [errorText]="data.cityErrorMessage"
          >
            <input
              vinnova-text-input
              id="{{ name }}-city"
              formControlName="city"
              autocomplete="new-password"
              spellcheck="false"
              [error]="!!data.cityErrorMessage"
            />
          </lib-input-container>
        </div>
      </div>
      @if (!isForeign) {
        <div class="form-group">
          <lib-input-container
            [label]="t('worksite_municipality')"
            [for]="name + '-municipality'"
            [autoWidth]="false"
          >
            <lib-vinnova-dropdown
              [id]="name + '-municipality'"
              [placeholder]="t('worksite_select_municipality')"
              [items]="availableMunicipalities"
              formControlName="municipalityCode"
              [readonly]="isDisabled"
            >
            </lib-vinnova-dropdown>
          </lib-input-container>
        </div>
      }
      @if (!isForeign) {
        <div class="form-group">
          <!-- Län -->
          <lib-input-container
            [label]="t('worksite_county')"
            [for]="name + '-county'"
            [autoWidth]="false"
          >
            <lib-vinnova-dropdown
              [id]="name + '-county'"
              [placeholder]="t('worksite_select_county')"
              [items]="availableCounties"
              formControlName="countyCode"
              [readonly]="isDisabled"
            >
            </lib-vinnova-dropdown>
          </lib-input-container>
        </div>
      }
    </div>
  }
</ng-container>
